import "./Videos.css"
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Skeleton from "../../components/Skeleton";
import { Helmet } from "react-helmet-async";

const  Videos = ({ dark, MyBaseUrl }) => {

    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);

    const [activeVideo, setActiveVideo] = useState(null);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);

    useEffect(() => {
        setLoading(true);

        fetch(`${MyBaseUrl}/posts/videos?page=${page}`)
            .then(res => res.json())
            .then(data => {
                setVideos(data?.data?.data || []);
                setLastPage(data?.data?.meta?.last_page || 1);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    }, [page]);

    const getThumbnail = (url) => {
        if (!url) return "";
        const id = url.split("/embed/")[1];
        return `https://img.youtube.com/vi/${id}/0.jpg`;
    };

    return <div className="homer">
      <Helmet>
        <title>Football Videos | Video Highlights & Match Replays | FadaSports</title>
        <meta name="description" content="Watch football video highlights, match replays, player performances, and the best moments from your favorite teams and leagues." />
        <meta name="keywords" content="football videos, match highlights, video highlights, football replays, goal videos, sports videos, match videos" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Football Videos | FadaSports" />
        <meta property="og:description" content="Watch the best football videos, match highlights, and memorable moments." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>
        <section className="videosWrapper">
            <h1 style={dark ? {color: "#fff"} : {color: "#111111e7"}}>Videos</h1>
            <p style={dark ? {color: "#ebebebff"} : {color: "#3b3b3bff"}}>Watch your favorite team compete in real-time...</p>
            
            <div className="videosContainer">

                {loading ? (
                     <Skeleton dark={dark} count={6} />
                ) : (
                    videos.map((video, index) => (
                        <div 
                            className="videoCard" 
                            key={video.id || index}
                            onClick={() => setActiveVideo(video?.metadata?.video_url)}
                            style={dark ? { backgroundColor: "#1a1a1a" } : {}}
                        >
                            <img 
                                src={getThumbnail(video?.metadata?.video_url) || video.image} 
                                alt={video.title} 
                            />

                            <NavLink 
                                to={`/videos/${video.slug}`} 
                                state={{ video }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <h3>
                                    {video.title}
                                </h3>
                            </NavLink>

                            <span>
                              <p>
                                {video.metadata?.duration}
                              </p>
                              
                              <NavLink 
                                to={`/videos/${video.slug}`} 
                                state={{ video }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <p>
                                    watch video
                                </p>
                              </NavLink>
                            </span>
                        </div>
                    ))
                )}

            </div>

            {/* <div className="pagination">
                <button 
                    disabled={page === 1}
                    onClick={() => setPage(prev => prev - 1)}
                >
                    Prev
                </button>

                <span>Page {page} of {lastPage}</span>

                <button 
                    disabled={page === lastPage}
                    onClick={() => setPage(prev => prev + 1)}
                >
                    Next
                </button>
            </div> */}

            {/* {activeVideo && (
                <div className="videoModal" onClick={() => setActiveVideo(null)}>
                    <div className="videoModalContent" onClick={(e) => e.stopPropagation()}>
                        <iframe
                            width="100%"
                            height="400"
                            src={`${activeVideo}?autoplay=1`}
                            title="video player"
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                        />
                    </div>
                </div>
            )} */}

        </section>

      
    </div>
};

export default Videos;